const EVENT_ATTRIBUTE = 'data-gtm-event';
const GTM_ATTRIBUTE_PREFIX = 'data-gtm-';
const EVENT_ARGUMENT_SCHEMAS = {
    // Порядок аргументов должен совпадать с GTM.application_submit().
    application_submit: [
        { attribute: 'data-gtm-page-category', required: true },
        { attribute: 'data-gtm-method', required: true },
        { attribute: 'data-gtm-partner-type', required: true },
        { attribute: 'data-gtm-partner-name', required: true },
        { attribute: 'data-gtm-product-name', required: false },
        { attribute: 'data-gtm-affiliation', required: false },
        { attribute: 'data-gtm-segment', required: true },
    ],
    bank_partners_page: [
        { attribute: 'data-gtm-partner-name', required: true },
    ],
    move_to_partner: [
        { attribute: 'data-gtm-partner-name', required: true },
    ],
};

function warnAboutInvalidSchema(logger) {
    logger?.warn?.('GTM event skipped: invalid data attribute schema');
}

export function sendGtmEventFromElement(element, gtm, logger = console) {
    const eventName = element?.getAttribute?.(EVENT_ATTRIBUTE);
    if (!eventName || !gtm || typeof gtm.send !== 'function') {
        return false;
    }

    const schema = EVENT_ARGUMENT_SCHEMAS[eventName];
    if (!schema) {
        warnAboutInvalidSchema(logger);
        return false;
    }

    const allowedAttributes = new Set([EVENT_ATTRIBUTE, ...schema.map(({ attribute }) => attribute)]);
    const hasUnknownAttribute = Array.from(element.attributes)
        .some(({ name }) => name.startsWith(GTM_ATTRIBUTE_PREFIX) && !allowedAttributes.has(name));
    const hasMissingRequiredAttribute = schema
        .some(({ attribute, required }) => required && element.getAttribute(attribute) === null);

    if (hasUnknownAttribute || hasMissingRequiredAttribute) {
        warnAboutInvalidSchema(logger);
        return false;
    }

    const args = schema.map(({ attribute }) => element.getAttribute(attribute) ?? '');

    gtm.send(eventName, ...args);

    return true;
}

export function registerGtmClickHandler(root = document, resolveGtm = () => window.GTM) {
    const handleClick = (event) => {
        const element = event.target?.closest?.(`[${EVENT_ATTRIBUTE}]`);

        if (element) {
            sendGtmEventFromElement(element, resolveGtm());
        }
    };

    root.addEventListener('click', handleClick);

    return () => root.removeEventListener('click', handleClick);
}
